<template>
  <GBox class="announcements">
    <GCard
      class="announcement"
      v-for="(announcement, idx) in announcements"
      :key="idx"
    >
      <GBox
        flex
        align="center"
        :p="12"
      >
        <GBox>
          <GImage
            :src="iconSrc(announcement)"
            :width="42"
            :height="42"
            default-image="https://cdn.dsmcdn.com/seller-center/shared/common/1x1.png"
          />
        </GBox>
        <GBox :ml="20">
          <GText variant="subtitle-01">
            {{ announcement.title }}
          </GText>
          <GText>{{ announcement.content }}</GText>
        </GBox>
      </GBox>
    </GCard>
  </GBox>
</template>

<script>
import GCard from '@trendyol-js/grace/core/GCard';
import GText from '@trendyol-js/grace/core/GText';
import GImage from '@trendyol-js/grace/core/GImage';
import GBox from '@trendyol-js/grace/core/GBox';
export default {
  name: 'AnnouncementWidgets',

  components: {
    GCard,
    GBox,
    GText,
    GImage,
  },

  computed: {
    announcements () {
      return [
        {
          title: '98 BİN',
          content: 'İşletme',
          icon: 'store.svg',
        },
        {
          title: '1.1 MİLYON',
          content: 'Bireysel Satıcı',
          icon: 'people.svg',
        },
        {
          title: '347 MİLYON',
          content: 'Adet Ürün Satışı',
          icon: 'boxes.svg',
        },
      ];
    },
  },

  methods: {
    iconSrc ({ icon }) {
      return `https://cdn.dsmcdn.com/seller-center/account/images/${icon}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.announcements {
  display: flex;

  .announcement {
    flex: 1;

    &::v-deep > .body {
      height: 100%;
      display: flex;
      align-items: center;
    }

    &:not(:last-child) {
      margin-right: 30px;
    }
  }

  @media only screen and (max-width:767px) {
    flex-direction: column;

    .announcement {
      width: 100%;
    }

    ::v-deep .g-card {
      >  .body {
        padding: 10px;
      }
    }
  }

  @media only screen and (max-width:1024px) {
    ::v-deep .g-card {
      >  .body {
        padding: 10px;
      }
    }
  }

  @media only screen and (max-width:1200px) {
    ::v-deep .g-card {
      >  .body {
        padding: 10px;
      }
    }
  }
}
</style>
